import type { GifteeBoxIssueCounts } from '@common/api/graphql/getIssueCountsGql';
import type { AppAction } from '../actions/actionType';
import { AppActionTypes } from '../actions/actionType';

const gifteeBoxIssueCounts = (
  state: GifteeBoxIssueCounts = [],
  action: AppAction
): GifteeBoxIssueCounts => {
  switch (action.type) {
    case AppActionTypes.GET_ISSUE_COUNTS_SUCCESS:
      return action.issueCountResult.gifteeBoxResults;
    default:
      return state;
  }
};

export default gifteeBoxIssueCounts;
